import { Fragment, ReactElement } from 'react';
import { PersonOutlineTwoTone, Inventory } from '@mui/icons-material';

const IconHistorian = (): ReactElement => {
  return (
    <Fragment>
      <PersonOutlineTwoTone color="inherit" />
      <Inventory color="inherit" />
    </Fragment>
  );
};

IconHistorian.displayName = 'IconHistorian';

export default IconHistorian;
